import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HinweisboxTypeEnum } from './hinweisbox-type.enum';

type HeaderSize = 'h2' | 'h3' | 'h4' | 'h5';

@Component({
    selector: 'pf-hinweisbox',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './hinweisbox.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HinweisboxComponent {
    @Input({ required: true }) boxType!: HinweisboxTypeEnum;
    @Input() boxId = '';
    @Input() boxTitle = '';
    @Input() boxMessage = '';
    @Input() headerSize: HeaderSize = 'h3';
    @Input() additionalClasses: string | string[] = '';
    @Input() role :  'alert' | 'note';

    getRole(): 'alert' | 'note' {
        return this.role ?? this.calculateRole();
    }
    
    /** ARIA-Rolle je nach Typ */
    private calculateRole():'alert' | 'note'{
        switch (this.boxType) {
            case HinweisboxTypeEnum.ERROR:
            case HinweisboxTypeEnum.WARNING:
                return 'alert';
            case HinweisboxTypeEnum.INFO:
            case HinweisboxTypeEnum.SUCCESS:
            default:
                return 'note';
        }
    }
}
